import { useMemo } from 'react';

import { useCurrentJob } from 'hooks';
import { FormattedJob } from 'types';

export interface ReduxContainerComponentChildrenArgs {
  job?: FormattedJob;
  isLoading: boolean;
  showLineItems: boolean;
}

export interface ReduxContainerComponentProps {
  children: (args: ReduxContainerComponentChildrenArgs) => JSX.Element;
}

const ReduxContainerComponent = ({
  children,
}: ReduxContainerComponentProps) => {
  const { job, isLoading } = useCurrentJob();

  const showLineItems = useMemo(() => {
    if (!job) return true;
    const checkoutOptions = job?.checkout_options;
    if (checkoutOptions?.includes('apply_for_finance')) return true;
    return false;
  }, [job]);

  return children({
    job,
    isLoading,
    showLineItems,
  });
};

ReduxContainerComponent.displayName = 'JobSidebar-reduxContainer';

export default ReduxContainerComponent;
